import { useEffect, useState } from "react";
import { api, formatDateTime } from "../lib/api";
import { useT } from "../i18n/I18nContext";
import { FileText } from "lucide-react";

export default function AuditLogPage() {
  const t = useT();
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/audit-log");
        setLogs(data);
      } catch {
        // ignore
      }
    })();
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-5 md:px-8 py-8">
      <div className="flex items-center gap-3 mb-6">
        <FileText className="w-6 h-6 text-[#0F4C3A]" />
        <div>
          <div className="nv-label">{t("nav.audit")}</div>
          <h1 className="font-heading text-3xl font-medium text-[#0F4C3A]" data-testid="audit-log-title">{t("audit.title")}</h1>
        </div>
      </div>
      <div className="nv-border bg-white rounded-md overflow-x-auto">
        <table className="w-full min-w-[640px]">
          <thead className="bg-[#F8FAF9] border-b border-[#E2E8E4]">
            <tr>
              <th className="nv-label p-3 text-left whitespace-nowrap">{t("audit.col.time")}</th>
              <th className="nv-label p-3 text-left whitespace-nowrap">{t("audit.col.user")}</th>
              <th className="nv-label p-3 text-left whitespace-nowrap">{t("audit.col.role")}</th>
              <th className="nv-label p-3 text-left whitespace-nowrap">{t("audit.col.action")}</th>
              <th className="nv-label p-3 text-left whitespace-nowrap">{t("audit.col.entity")}</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id} className="border-b border-[#E2E8E4] hover:bg-[#F8FAF9]" data-testid={`audit-row-${log.id}`}>
                <td className="p-3 text-xs text-[#475569] font-mono-nv">{formatDateTime(log.created_at)}</td>
                <td className="p-3 text-sm">{log.user_email}</td>
                <td className="p-3 text-xs text-[#94A3B8] uppercase tracking-wider">{log.user_role}</td>
                <td className="p-3"><span className="font-mono-nv text-xs bg-[#0F4C3A] text-white px-2 py-0.5 rounded">{log.action}</span></td>
                <td className="p-3 text-xs text-[#475569]">{log.entity_type} {log.entity_id?.slice(0, 8)}</td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr><td colSpan={5} className="p-10 text-center text-[#94A3B8]">{t("audit.no_data")}</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
